require('./transferShowContainer.scss')

module.exports = {
  template: require('./transferShowContainer.pug')()
  controller: require('./transferShowContainer.ctrl')
}
